// extracted by mini-css-extract-plugin
module.exports = {"locationCard":"LocationCard_locationCard__1oISu","locationCardContainer":"LocationCard_locationCardContainer__1kmi9","info":"LocationCard_info__jO3og"};